import { isObject } from "./is-object";

export const SENSITIVE_FIELD_KEYS: ReadonlySet<string> = new Set([
  // Bank details
  "account_number",
  "sort_code",
  "account_holder",
  // Payment / anti-bot tokens. "nonce" is a Braintree-owned key inside the
  // driver's gateway_payload, not a term of the generic contract (#963): the
  // list masks whatever keys the active driver writes there.
  "nonce",
  "cf-turnstile-response",
  // A shared preview link (#1109) is `?expires=...&signature=...`: with the pair
  // an error event would carry the working link.
  "signature",
  "expires",
  // Donor identity (submission payload / store state variants)
  "name",
  "first_name",
  "firstName",
  "last_name",
  "lastName",
  "forename",
  "surname",
  "honouringForename",
  "honouringSurname",
  "honouring_forename",
  "honouring_surname",
  "sendCardToTitle",
  "sendCardToForename",
  "sendCardToSurname",
  // Contact details
  "email",
  "confirm_email",
  "confirmEmail",
  "phone",
  // Postal address (snake_case submission and kebab-case store variants)
  "address_line_1",
  "address_line_2",
  "address-line-1",
  "address-line-2",
  "city",
  "region",
  "postal_code",
  "postal-code",
  "postcode",
  "country",
  // Organisation the donation is made on behalf of
  "organisationName",
  "organisation_name",
  "donation_org_name",
]);

export const MASK = "****";

export function maskSensitiveFields<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => maskSensitiveFields(item)) as unknown as T;
  }

  if (isObject(value)) {
    const result: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value)) {
      if (SENSITIVE_FIELD_KEYS.has(key) && val !== null && val !== undefined) {
        result[key] = MASK;
      } else {
        result[key] = maskSensitiveFields(val);
      }
    }
    return result as T;
  }

  return value;
}
